export const environment = {
  production: false,
  apiUrl: '/api',  // Use relative URL for nginx proxy
  websocketUrl: '', // Use current origin (empty string = same origin, will use proxy)
  syncConfig: {
    enhancedSyncEnabled: true,
    websocketEnabled: true,
    fallbackToLegacy: true,
    maxReconnectAttempts: 5,
    reconnectDelay: 1000,
    debugLogging: true
  },
  version: '1.3.10',
  buildDate: '2026-10-23T10:44:17.431Z',
  gitCommit: 'a92838c'
};